var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7953 5.34766L26.8047 16.4814L29.5768 9.91263L41.7953 5.34766Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18934 5.34766L22.0594 16.5868L19.4229 9.91263L7.18934 5.34766ZM36.4021 31.1556L32.4097 37.2723L40.9521 39.6226L43.4078 31.2912L36.4021 31.1556ZM5.60742 31.2912L8.0481 39.6226L16.5905 37.2723L12.598 31.1556L5.60742 31.2912Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.108 20.8211L13.7275 24.4218L22.2096 24.7985L21.9083 15.6836L16.108 20.8211ZM32.8763 20.8211L27.0006 15.5781L26.8048 24.7985L35.2718 24.4218L32.8763 20.8211ZM16.5901 37.273L21.6823 34.7872L17.2831 31.3521L16.5901 37.273ZM27.3019 34.7872L32.4093 37.273L31.7012 31.3521L27.3019 34.7872Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.41 37.273L27.3027 34.7871L27.7095 38.1167L27.6643 39.5178L32.41 37.273ZM16.5908 37.273L21.3366 39.5178L21.3065 38.1167L21.6831 34.7871L16.5908 37.273Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4117 29.1527L17.1631 27.9022L20.1612 26.5312L21.4117 29.1527ZM27.5736 29.1527L28.8241 26.5312L31.8373 27.9022L27.5736 29.1527Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5901 37.2731L17.3133 31.1563L12.5977 31.2919L16.5901 37.2731ZM31.6862 31.1563L32.4093 37.2731L36.4018 31.2919L31.6862 31.1563ZM35.2719 24.4219L26.8048 24.7985L27.5882 29.1526L28.8387 26.5311L31.8519 27.9021L35.2719 24.4219ZM17.1626 27.9021L20.1758 26.5311L21.4112 29.1526L22.2097 24.7985L13.7276 24.4219L17.1626 27.9021Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7275 24.4219L17.2831 31.3522L17.1626 27.9021L13.7275 24.4219ZM31.8518 27.9021L31.7012 31.3522L35.2718 24.4219L31.8518 27.9021ZM22.2096 24.7985L21.4112 29.1526L22.4055 34.29L22.6315 27.5255L22.2096 24.7985ZM26.8048 24.7985L26.398 27.5104L26.5788 34.29L27.5882 29.1526L26.8048 24.7985Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5887 29.1528L26.5793 34.2903L27.3024 34.7875L31.7017 31.3524L31.8524 27.9023L27.5887 29.1528ZM17.1631 27.9023L17.2836 31.3524L21.6829 34.7875L22.406 34.2903L21.4117 29.1528L17.1631 27.9023Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6643 39.5183L27.7095 38.1171L27.3328 37.7857H21.653L21.3065 38.1171L21.3366 39.5183L16.5908 37.2734L18.2481 38.6294L21.6078 40.9646H27.378L30.7528 38.6294L32.41 37.2734L27.6643 39.5183Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3019 34.7862L26.5787 34.2891H22.4055L21.6823 34.7862L21.3057 38.1158L21.6522 37.7844H27.332L27.7087 38.1158L27.3019 34.7862Z",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4285 17.2045L43.7091 11.0576L41.7957 5.34766L27.3023 16.1047L32.8767 20.8203L40.7562 23.1254L42.5038 21.0915L41.7505 20.5492L42.9558 19.4494L42.0217 18.7262L43.227 17.8072L42.4285 17.2045ZM5.29102 11.0576L6.57162 17.2045L5.75806 17.8072L6.96333 18.7262L6.04431 19.4494L7.24958 20.5492L6.49629 21.0915L8.22887 23.1254L16.1083 20.8203L21.6827 16.1047L7.18932 5.34766L5.29102 11.0576Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7562 23.1269L32.8767 20.8218L35.2722 24.4225L31.7016 31.3529L36.4021 31.2926H43.4078L40.7562 23.1269ZM16.1084 20.8218L8.22889 23.1269L5.60742 31.2926H12.598L17.2835 31.3529L13.728 24.4225L16.1084 20.8218ZM26.8052 24.7992L27.3023 16.1062L29.5924 9.91406H19.4229L21.6828 16.1062L22.2101 24.7992L22.3909 27.5412L22.4059 34.2907H26.5792L26.6093 27.5412L26.8052 24.7992Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.33e4fe5f46d684b06a9bf7c8c5766310.svg";
export { ForwardRef as ReactComponent };